import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/admin/dashboard`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [navigate]);

  if (loading) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="row mb-4">
        <div className="col-md-12">
          <h1>Admin Dashboard</h1>
          <hr />
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card text-center bg-primary text-white">
            <div className="card-body">
              <h5 className="card-title">Total Users</h5>
              <h2>{stats?.total_users || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center bg-success text-white">
            <div className="card-body">
              <h5 className="card-title">Total Appointments</h5>
              <h2>{stats?.total_appointments || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center bg-warning text-white">
            <div className="card-body">
              <h5 className="card-title">Pending Appointments</h5>
              <h2>{stats?.pending_appointments || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center bg-info text-white">
            <div className="card-body">
              <h5 className="card-title">Completed Appointments</h5>
              <h2>{stats?.completed_appointments || 0}</h2>
            </div>
          </div>
        </div>
      </div>

      {/* More Stats */}
      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5 className="card-title">Services</h5>
              <h2>{stats?.total_services || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5 className="card-title">Events</h5>
              <h2>{stats?.total_events || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5 className="card-title">Active Coupons</h5>
              <h2>{stats?.active_coupons || 0}</h2>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card text-center">
            <div className="card-body">
              <h5 className="card-title">Testimonials</h5>
              <h2>{stats?.total_testimonials || 0}</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Appointments */}
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card">
            <div className="card-header">
              <h5>Recent Appointments</h5>
            </div>
            <div className="card-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>Doctor</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recent_appointments?.map((apt) => (
                    <tr key={apt.id}>
                      <td>{apt.user?.name}</td>
                      <td>{apt.doctor?.name}</td>
                      <td>
                        <span className={`badge bg-${apt.status === 'completed' ? 'success' : apt.status === 'pending' ? 'warning' : 'danger'}`}>
                          {apt.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Recent Users */}
        <div className="col-md-6 mb-4">
          <div className="card">
            <div className="card-header">
              <h5>Recent Users</h5>
            </div>
            <div className="card-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {stats?.recent_users?.map((user) => (
                    <tr key={user.id}>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.phone || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Links */}
      <div className="row">
        <div className="col-md-12 mb-4">
          <div className="card">
            <div className="card-header">
              <h5>Quick Links</h5>
            </div>
            <div className="card-body">
              <div className="btn-group" role="group">
                <button type="button" className="btn btn-outline-primary" onClick={() => navigate('/admin/sliders')}>
                  Manage Sliders
                </button>
                <button type="button" className="btn btn-outline-primary" onClick={() => navigate('/admin/categories')}>
                  Categories
                </button>
                <button type="button" className="btn btn-outline-primary" onClick={() => navigate('/admin/services')}>
                  Services
                </button>
                <button type="button" className="btn btn-outline-primary" onClick={() => navigate('/admin/events')}>
                  Events
                </button>
                <button type="button" className="btn btn-outline-primary" onClick={() => navigate('/admin/users')}>
                  Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
